export const DETAIL_PAGE_SEE_OTHER_STAYS_OPTIONS_CLICKED = 'DETAIL_PAGE_SEE_OTHER_STAYS_OPTIONS_CLICKED';
export const DETAIL_PAGE_SEE_OTHER_STAYS_OPTIONS_CLICKED_VERSION = '1.0';

export type DetailPageSeeOtherStaysOptionsClickedPayload = {
  searchId: string;
  productDetailKey: string;
};

export type DetailPageSeeOtherStaysOptionsClickedParams = {
  searchId: string;
  productDetailKey: string;
};

export const createDetailPageSeeOtherStaysOptionsClickedPayload = ({
  searchId,
  productDetailKey,
}: DetailPageSeeOtherStaysOptionsClickedParams): DetailPageSeeOtherStaysOptionsClickedPayload => ({
  searchId,
  productDetailKey,
});
